let frameId = 0;
let running = false;
let lastTime = 0;
let accumulator = 0;

export function startLoop(options = {}) {
  const {
    update = () => {},
    render = () => {},
    fixedStep = 1 / 60,
    maxFrameDelta = 0.034,
    fpsCap = 60,
    getHitStop = () => 0,
    setHitStop = () => {},
    hitStopScale = 0.2,
  } = options;

  stopLoop();

  const minFrameMs = 1000 / fpsCap;
  running = true;
  lastTime = performance.now();
  accumulator = 0;

  function frame(now = performance.now()) {
    if (!running) return;
    frameId = requestAnimationFrame(frame);
    if (now - lastTime < minFrameMs) return;

    let dt = Math.min(maxFrameDelta, (now - lastTime) / 1000);
    lastTime = now;

    const hitStop = getHitStop();
    if (hitStop > 0) {
      setHitStop(Math.max(0, hitStop - dt));
      dt *= hitStopScale;
    }

    accumulator += dt;
    while (accumulator >= fixedStep) {
      update(fixedStep);
      accumulator -= fixedStep;
    }

    render(dt);
  }

  frameId = requestAnimationFrame(frame);
  return stopLoop;
}

export function stopLoop() {
  if (frameId) {
    cancelAnimationFrame(frameId);
    frameId = 0;
  }
  running = false;
  accumulator = 0;
}

export function isLoopRunning() {
  return running;
}
